import { render, staticRenderFns } from "./BoletosFinanceiro.vue?vue&type=template&id=b1b91c48"
import script from "./BoletosFinanceiro.vue?vue&type=script&lang=js"
export * from "./BoletosFinanceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports